import axios from "axios";

const api = axios.create({
    baseURL: 
      window.env?.REACT_APP_BASE_URL && window.env.REACT_APP_BASE_URL !== "REACT_APP_BASE_URL_PLACEHOLDER"
        ? window.env.REACT_APP_BASE_URL
        : 'https://angatuportas.com.br/api/v1',
    headers: {
        'Content-Type': 'application/json',
    }
  });

export default api;